import React from 'react';
import LegalPageShell from '../components/LegalPageShell';

const sections = [
  {
    num: 1,
    title: 'Customer Support',
    content: (
      <>
        <p>For any product question, account help, billing issue, or technical bug, please reach us at:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a> &mdash; we respond within 24 working hours.</li>
          <li><strong>Working hours:</strong> Monday &ndash; Saturday, 10:00 AM &ndash; 7:00 PM IST. Closed on Sunday and Indian public holidays.</li>
          <li><strong>In-app:</strong> Use the WhatsApp / Phone floating chat on the bottom-right of any screen for the fastest response.</li>
        </ul>
      </>
    ),
  },
  {
    num: 2,
    title: 'Grievance Officer (DPDP Act, 2023)',
    content: (
      <>
        <p>For any concern regarding your personal data, privacy, refund disputes, or service grievance:</p>
        <p style={{ marginTop: 8 }}>
          <strong>Mr. Mandeep Singh Chadha</strong><br />
          Director &amp; Grievance Officer<br />
          Taraanaya Vedtech Private Limited<br />
          Email: <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a>
        </p>
        <p>We acknowledge grievances within 48 working hours and resolve them within 30 days as required by the Digital Personal Data Protection Act, 2023.</p>
      </>
    ),
  },
  {
    num: 3,
    title: 'Registered Office',
    content: (
      <p>
        Taraanaya Vedtech Private Limited<br />
        C-3/101, 1st Floor, Tower C3, Cleo County, Sector 121,<br />
        Noida, Gautam Buddha Nagar, Uttar Pradesh &ndash; 201301, India<br />
        <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>CIN: U96906UW2026PTC249734 &middot; Registered with Central Registration Centre (RoC, MCA)</span>
      </p>
    ),
  },
  {
    num: 4,
    title: 'Business Enquiries',
    content: (
      <p>
        For partnerships, B2B integrations, press, careers, or other business enquiries, please email
        {' '}<a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a> with the subject prefix
        &ldquo;[Business] &mdash; Your topic&rdquo;. We respond within 3&ndash;5 working days.
      </p>
    ),
  },
  {
    num: 5,
    title: 'Quick Links',
    content: (
      <ul>
        <li><a href="/about">About Taraanaya</a></li>
        <li><a href="/pricing">Pricing &amp; Plans</a></li>
        <li><a href="/refund-policy">Refund &amp; Cancellation Policy</a></li>
        <li><a href="/privacy-policy">Privacy Policy</a></li>
        <li><a href="/terms-of-service">Terms of Service</a></li>
      </ul>
    ),
  },
];

export default function ContactPage() {
  return (
    <LegalPageShell
      title="Contact Us"
      subtitle="We&rsquo;re here to help. Reach us by email any time, and a human will respond during working hours."
      sections={sections}
      dataTestId="contact-page"
    />
  );
}
